import React, { useState } from "react";
import { formatDate } from "../../../helpers/FormatHelper";
import { searchBankNotesForAuthorization, searchBankNotesForPickAndPack, searchBankNotesToSetReceivedManually, searchForAuthorizationOfOrderedNotes, updateOrderStatus } from "../../../networking/NetworkingBankNotes";
import { getStyle } from "../../../styles/styles";
import DatePicker from "../../shared/DatePicker";
import NewEditableGrid from "../../shared/NewEditableGrid";
import { useEffect } from "react";
import { LocalMallOutlined, ZoomInOutlined } from "@material-ui/icons";
import EditBnOrder from "./EditOrder";
import AlertBox from "../../shared/AlertBox";
import { equalsIgnoreCase } from '../../../helpers/StringHelper'
import PickAndPackContext from "./PickAndContext";
import { useContext } from "react";

const style = getStyle();

const ViewBnOrders = (props) => {

    const { lockedSide, deliveryStatusFixed, userAction } = props
    
    const {
        setLockedSide,
        bankNoteOrder,
        getBankOrder,
        lookUpTables,
        setSellDeliveryStatusOptions,
        sellDeliveryStatusOptions,
        setBuyDeliveryStatusOptions,
        buyDeliveryStatusOptions,
        reviewPurchaseOrders,
        setReviewPurchaseOrders,
        canViewInventoryBalances,
        setCanViewInventoryBalances,
        toSetAsReceivedManually,
        setToSetAsReceivedManually,
        reviewAndAuthorizeSellOrders,
        setReviewAndAuthorizeSellOrders,
        systemDate,
        eodIsValid,
        loading

    } = useContext(PickAndPackContext);

    if (userAction === 'ReviewPurchaseOrders') {
        setReviewPurchaseOrders(true)
        setCanViewInventoryBalances(false)
    }

    if (userAction === 'SetReceivedManually') {
        setToSetAsReceivedManually(true)
        setCanViewInventoryBalances(false)
    } 

    if(userAction === 'ReviewAndAuthorizeSellOrders') {
        setReviewAndAuthorizeSellOrders(true)
        setCanViewInventoryBalances(true)
    }

    let deliveryOptions = lookUpTables[equalsIgnoreCase(lockedSide, 'Buy') ? 'BNDeliveryBuyStatus' : 'BNDeliverySellStatus'] || []

    if (equalsIgnoreCase(lockedSide, "Sell") && Array.isArray(sellDeliveryStatusOptions) && sellDeliveryStatusOptions.length > 0) {
        deliveryOptions = deliveryOptions.filter(
            (d) =>
                Array.isArray(sellDeliveryStatusOptions) &&
                sellDeliveryStatusOptions.includes(d.value) && !equalsIgnoreCase(d.value, 'completed')
        );
    }

    if (equalsIgnoreCase(lockedSide, "Buy") && Array.isArray(buyDeliveryStatusOptions) && buyDeliveryStatusOptions.length > 0) {
        deliveryOptions = deliveryOptions.filter(
            (d) =>
                Array.isArray(buyDeliveryStatusOptions) &&
                buyDeliveryStatusOptions.includes(d.value) && !equalsIgnoreCase(d.value, 'confirmed')
        );
    }

    setLockedSide(lockedSide)

    const fixedStatusActions = ['SetReceivedManually', 'ReviewAndAuthorizeSellOrders', 'ReviewPurchaseOrders']
    const deliveryStatusIsFixed = deliveryStatusFixed !== undefined && deliveryStatusFixed !== null && fixedStatusActions.includes(userAction)

    const [data, setData] = useState([]);
    const [columnDetail, setColumnDetail] = useState(null);        
    const [deliveryStatus, setDeliveryStatus] = useState(
        deliveryStatusIsFixed ? deliveryStatusFixed : equalsIgnoreCase(lockedSide, 'Sell') ? 'Pending' : 'Ready for delivery');
    const [deliveryStatusForPrepareOrder, setDeliveryStatusForPrepareOrder] = useState('In Progress')

    const now = new Date()
    const [fromDate, setFromDate] = useState(formatDate(new Date(now.getFullYear(), now.getMonth(), 1)));
    const [toDate, setToDate] = useState(formatDate(now));

    const [orderIdToShow, setOrderIdToShow] = useState(0)    
    const [orderIdSelected, setOrderIdSelected] = useState(0)
    const [orderSelected, setOrderSelected] = useState({})

    const [refresh, setRefresh] = useState(false)
    const [refreshSelectedOrder, setRefreshSelectedOrder] = useState(false)

    const [confirmMessage, setconfirmMessage] = useState({ show: false, title: '', message: '' })
    const [alertMessage, setAlertMessage] = useState({ show: false, title: '', message: '' })

    useEffect(() => {
        onRefresh()
    }, [])

    useEffect(() => { onRefresh() }, [refresh])

    useEffect(() => {
        const load = async () => {
            await getBankOrder(orderIdToShow)            
        }
        if (orderIdToShow > 0) {
            load().finally()
        }
    }, [orderIdToShow, refreshSelectedOrder])

    const onRefresh = () => {
        refreshOrders().finally()
    }

    const refreshOrders = async () => {
        if (equalsIgnoreCase(userAction, 'ReviewPurchaseOrders')) {
            const response = await searchBankNotesForAuthorization(0, fromDate, toDate)
            if (Array.isArray(response.result)) {
                setData(response.result.filter(x => equalsIgnoreCase(x.BuySell, lockedSide)))
            }
            else {
                setData(response.result)
            }
            if (response && response.columnDetail != null) {
                const _columnDetail = JSON.parse(response.columnDetail);
                console.log('_columnDetail ', _columnDetail)
                setColumnDetail(_columnDetail);
            }
            return;
        }
        else if (equalsIgnoreCase(userAction, 'SetReceivedManually')) {
            const response = await searchBankNotesToSetReceivedManually(0, fromDate, toDate)
            if (Array.isArray(response.result)) {
                setData(response.result.filter(x => equalsIgnoreCase(x.BuySell, lockedSide)))
            }
            else {
                setData(response.result)
            }
            if (response && response.columnDetail != null) {
                const _columnDetail = JSON.parse(response.columnDetail);
                console.log('_columnDetail ', _columnDetail)
                setColumnDetail(_columnDetail);
            }
            return;
        }
        else if (equalsIgnoreCase(userAction, 'ReviewAndAuthorizeSellOrders')) {
            const response = await searchForAuthorizationOfOrderedNotes(0, fromDate, toDate)
            if (Array.isArray(response.result)) {
                setData(response.result.filter(x => equalsIgnoreCase(x.BuySell, lockedSide)))
            }
            else {
                setData(response.result)
            }
            if (response && response.columnDetail != null) {
                const _columnDetail = JSON.parse(response.columnDetail);
                console.log('_columnDetail ', _columnDetail)
                setColumnDetail(_columnDetail);
            }
            return;
        }

        const response = await searchBankNotesForPickAndPack(0, fromDate, toDate, 'Accepted', deliveryStatus)
        if (Array.isArray(response.result)) {
            setData(response.result.filter(x => equalsIgnoreCase(x.BuySell, lockedSide)))
        }
        else {
            setData(response.result)
        }
        if (response && response.columnDetail != null) {
            const _columnDetail = JSON.parse(response.columnDetail);
            setColumnDetail(_columnDetail);
        }
        setDeliveryStatusForPrepareOrder(response.statusToPrepare || 'In Progress')
        setSellDeliveryStatusOptions(response.sellDeliveryStatusOptions || [])
        setBuyDeliveryStatusOptions(response.buyDeliveryStatusOptions || [])
    }

    const onPrepareOrderClick = (order) => {
        setOrderIdSelected(order.BNOrderNo)
        setOrderSelected(order)
        setconfirmMessage({
            ...confirmMessage, show: true, title: 'Confirm',
            message: `The order ${order.BNOrderNo} will be set as 'In Progress'. Are you sure you want to continue?`
        })
    }

    const handleRowClick = (order) => {
        setOrderIdToShow(order.BNOrderNo)
    }

    let dynamicActions = []
    const toBePrepared = !fixedStatusActions.includes(userAction) &&
        ((equalsIgnoreCase(deliveryStatus, 'Pending') && equalsIgnoreCase(lockedSide, 'Sell'))
            || ((equalsIgnoreCase(deliveryStatus, 'Ready for delivery') && equalsIgnoreCase(lockedSide, 'Buy'))))
    if (toBePrepared) {
        dynamicActions = [
            {
                name: "Prepare Order",
                function: onPrepareOrderClick,
                isIcon: true,
                icon: <LocalMallOutlined />,
            },
        ]
    } else if (equalsIgnoreCase(deliveryStatus, 'In Progress')) {
        dynamicActions = [
            {
                name: "Prepare Order",
                function: handleRowClick,
                isIcon: true,
                icon: <LocalMallOutlined />,
            },
        ]
    } else {
        dynamicActions = [
            {
                name: "View Order",
                function: handleRowClick,
                isIcon: true,
                icon: <ZoomInOutlined />,
            },
        ]
    }

    const onConfirmUpdate = async () => {        
        closeConfirmMessage()
        const response = await updateOrderStatus(orderIdSelected, '', deliveryStatusForPrepareOrder, '', orderSelected.UpdateToken)
        console.log('onConfirmUpdate ', response)
        if (response !== undefined && response.success) {
            setOrderIdToShow(orderIdSelected)
        }
        else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }

    const closeConfirmMessage = () => {
        setconfirmMessage({ ...confirmMessage, show: false, title: '', message: '' })
    }

    const closeAlertMessage = () => {
        setAlertMessage({ ...alertMessage, show: false, title: '', message: '' })
    }

    const prepareOrder = orderIdToShow > 0

    let validateEod = false;
    let headingTitle
    switch (userAction) {
        case 'ReviewPurchaseOrders':
            headingTitle = 'Review purchase orders'
            break
        case 'SetReceivedManually':
            headingTitle = 'Set as Received Manually'
            break
        case 'ReviewAndAuthorizeSellOrders':
            headingTitle = 'Review and Authorize Sell Orders'
            validateEod = true
            break
        default:
            headingTitle = `Bank Notes - Pick & Pack (${equalsIgnoreCase(lockedSide, 'Sell') ? 'To shipped' : 'To receive'})`
            validateEod = true
            break
    }

    // if (validateEod && !eodIsValid) {
    //     return <div>
    //         <h3 className="uk-heading-divider" style={style.titleStyle} >{headingTitle}</h3>
    //         <div className="uk-alert-danger" uk-alert="true">
    //             <p>{`The system has not yet been reconcilied and closed for ${systemDate?.replaceAll('-', '/')}. Please contact your supervisor.`}</p>
    //         </div>
    //     </div>
    // }

    return <div>
        {prepareOrder ?
            <EditBnOrder
                orderNo={orderIdToShow}
                back={() => {
                    setOrderIdToShow(0);                    
                    setRefresh(!refresh)
                }}
                bankNoteOrder={bankNoteOrder}
                deliveryOptions={deliveryOptions !== undefined ? deliveryOptions.filter(x => x.value !== '') : []}
                refreshSelectedOrder={() => setRefreshSelectedOrder(!refreshSelectedOrder)}
                lockedSide={lockedSide}                
                />
            : <>
                <h3 className="uk-heading-divider" style={style.titleStyle} >{headingTitle}</h3>
                <div className="uk-grid">
                    <div className="uk-width-1-8">
                        <div className="uk-margin">
                            <label className="uk-form-label">From</label>
                            <div className="uk-form-controls">
                                <DatePicker
                                    id={'dp-bos-fromdate'}
                                    key={'dp-bos-fromdate'}
                                    className="uk-input"
                                    style={style.inputStyle}
                                    value={fromDate}
                                    onDayChange={(date) => {
                                        const _date = formatDate(date);
                                        setFromDate(_date);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-8">
                        <div className="uk-margin">
                            <label className="uk-form-label">To</label>
                            <div className="uk-form-controls">
                                <DatePicker
                                    id={'dp-bos-todate'}
                                    key={'dp-bos-todate'}
                                    className="uk-input"
                                    style={style.inputStyle}
                                    value={toDate}
                                    onDayChange={(date) => {
                                        const _date = formatDate(date);
                                        setToDate(_date);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {!deliveryStatusIsFixed && <div className="uk-width-1-4">
                        <div className="uk-margin">
                            <label className="uk-form-label" >Delivery Status</label>
                            <div className="uk-form-controls">
                                <select id="dp-bos-status-filter" className="uk-select"
                                    value={deliveryStatus}
                                    onChange={(e) => {
                                        setDeliveryStatus(e.target.value);
                                    }}
                                >
                                    {deliveryOptions.map((type) => (
                                        <option
                                            key={`status-option-${type.value}`}
                                            value={type.value}>{`${type.name}`}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>}
                    <div className="uk-width-1-8 uk-margin">
                        <button className="uk-button uk-button-green" type="button" onClick={() => onRefresh()}>Refresh</button>
                    </div>
                </div>
                <NewEditableGrid
                    id='grid-bnorders'
                    data={data}
                    columnDetails={columnDetail}
                    isEditable={false}
                    useIcons={true}
                    editSaveFunction={false}
                    canAdd={false}
                    addSaveFunction={false}
                    tableName={'orders'}
                    useExportButton={true}
                    dynamicActions={dynamicActions}
                    hiddenHeaders={equalsIgnoreCase('buy', lockedSide) ? ['TotalOrder', 'TotalFees'] : []}
                />
                <AlertBox id="warning-1" open={confirmMessage.show} onClose={closeConfirmMessage}
                    title={confirmMessage.title} message={confirmMessage.message} type="Yes/No"
                    yesClick={onConfirmUpdate} noClick={closeConfirmMessage} />
                <AlertBox id="alert-1" type="Ok" open={alertMessage.show} title={alertMessage.title} message={alertMessage.message}
                    okClick={closeAlertMessage} onClose={closeAlertMessage} />
            </>

        }
    </div>
};
export default ViewBnOrders;
